import { param } from "jquery";
import http from "../http-common";

// 請求書一覧の取得
const skya101 = params => {
    return http.get(`/sky/skya101`, {
        withCredentials: true,
        params: params
    });
}

// 請求書ダウンロード
const skya102 = (params) => {
    return http.get(`/sky/skya102`, {
        withCredentials: true,
        responseType: "blob",
        params: params
    })
};

const skyService = {
    skya101,
    skya102
}

export default skyService;